import React from 'react'
import { connect } from 'react-redux'


class IframePage extends React.Component {

  render() {
    const { mission_page } = this.props
    return (
      <iframe src={mission_page.iframe_url} height="600px" width="100%" frameBorder="0" />
    )
  }

}

IframePage.propTypes = {
  mission_page: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
  }).isRequired,
}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(IframePage)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/IframePage/index.jsx